import { RootInitialState } from 'src/redux/store/rootReducer';

export const getLocation = (state: RootInitialState) => state.location.location;

export const getLocationLoadingStatus = (state: RootInitialState) => state.location.loadingsStatus;
